export default "__VITE_ASSET__ce07252a__"